// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81')
];

export const server_loads = [];

export const dictionary = {
		"/(main)": [10,[3]],
		"/(main)/accrecs": [11,[3]],
		"/(main)/agentsales": [12,[3]],
		"/(main)/analytics": [13,[3]],
		"/(auth)/auth/callback": [9,[2]],
		"/(main)/contacts": [15,[3]],
		"/(main)/contact": [14,[3]],
		"/(main)/creditnote": [16,[3]],
		"/(pos)/discounts": [71,[6]],
		"/(main)/geolocations": [17,[3]],
		"/(main)/giftcardevents": [19,[3]],
		"/(main)/giftcards": [20,[3]],
		"/(main)/giftcard": [18,[3]],
		"/(main)/inventoryledger": [21,[3]],
		"/(main)/invoice": [22,[3]],
		"/(main)/itemsales": [24,[3]],
		"/(main)/itemsale": [23,[3]],
		"/(main)/jobs": [26,[3]],
		"/(main)/job": [25,[3]],
		"/(main)/layaways": [28,[3]],
		"/(main)/layaway": [27,[3]],
		"/(main)/location_transfer": [29,[3]],
		"/(public)/login": [73,[7]],
		"/(main)/memos": [31,[3]],
		"/(main)/memo": [30,[3]],
		"/(main)/models": [33,[3]],
		"/(main)/model": [32,[3]],
		"/(main)/news": [34,[3]],
		"/(main)/news/[slug]": [35,[3]],
		"/(main)/notabledates": [36,[3]],
		"/(main)/orders": [38,[3]],
		"/(main)/order": [37,[3]],
		"/(main)/orgs": [40,[3]],
		"/(main)/org": [39,[3]],
		"/(main)/payments": [41,[3]],
		"/(pos)/pos": [72,[6]],
		"/(main)/preferences": [42,[3]],
		"/(main)/prepayment": [43,[3]],
		"/(main)/quotes": [45,[3]],
		"/(main)/quote": [44,[3]],
		"/(main)/replenishment": [46,[3]],
		"/(main)/setshare": [47,[3]],
		"/(main)/settings/account": [48,[3,4,5]],
		"/(main)/settings/account/billing": [49,[3,4,5]],
		"/(main)/settings/account/data-export": [50,[3,4,5]],
		"/(main)/settings/account/document-logos": [51,[3,4,5]],
		"/(main)/settings/account/payments": [52,[3,4,5]],
		"/(main)/settings/account/solutions": [53,[3,4,5]],
		"/(main)/settings/account/store": [54,[3,4,5]],
		"/(main)/settings/account/tax": [55,[3,4,5]],
		"/(main)/settings/device": [56,[3,4]],
		"/(main)/settings/profile": [57,[3,4]],
		"/(main)/settings/team": [58,[3,4]],
		"/(main)/shopify": [59,[3]],
		"/(public)/signup": [74,[7,8]],
		"/(public)/signup/complete": [75,[7,8]],
		"/(public)/signup/owner": [76,[7,8]],
		"/(public)/signup/review": [77,[7,8]],
		"/(public)/signup/store": [78,[7,8]],
		"/(public)/signup/verify": [79,[7,8]],
		"/(main)/skus": [61,[3]],
		"/(main)/sku": [60,[3]],
		"/(public)/sms-privacy": [80,[7]],
		"/(public)/sms-terms": [81,[7]],
		"/(main)/solutions": [62,[3]],
		"/(main)/supplier_receiving": [63,[3]],
		"/(main)/supplier_returning": [64,[3]],
		"/(main)/transfers": [65,[3]],
		"/(main)/valuationcerts": [67,[3]],
		"/(main)/valuationcert": [66,[3]],
		"/(main)/wishes": [68,[3]],
		"/(main)/workshop_receiving": [69,[3]],
		"/(main)/xero": [70,[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);